module.exports = __webpack_public_path__ + "static/media/Hospitality_23.608ba557.jpg";